import { Component, Input } from '@angular/core';
import { TabPanelProps, tabPanelStyles } from '@kite_aerolab/shared/components';
import { animate, style, transition, trigger } from '@angular/animations';

export const tabPanelFadeAnimation = trigger('tabPanelFadeAnimation', [
  transition(':enter', [
    style({
      opacity: 0,
    }),
    animate(
      '300ms',
      style({
        opacity: 1,
      })
    ),
  ]),
  transition(':leave', [
    style({
      opacity: 1,
    }),
    animate(
      '0ms',
      style({
        opacity: 0,
      })
    ),
  ]),
]);

@Component({
  selector: 'kite-tab-panel',
  animations: [tabPanelFadeAnimation],
  template: `
    <div
      @tabPanelFadeAnimation
      *ngIf="activeIndex === index"
      [ngClass]="tabPanelStyles"
      [attr.aria-labelledby]="'tabs--tab-panel-' + index"
      tabIndex="0"
    >
      <ng-content></ng-content>
    </div>
  `,
})
export class TabPanelComponent {
  @Input() isActive: TabPanelProps['isActive'];
  @Input() index: TabPanelProps['index'];
  @Input() activeIndex: TabPanelProps['activeIndex'];
  @Input() css: TabPanelProps['css'];

  public get tabPanelStyles(): string[] {
    return [
      tabPanelStyles({
        isActive: this.activeIndex === this.index,
        css: this.css,
      }).className,
    ];
  }
}
